import { REWARD_OFFERING } from "../../constants";
import CompetitionPage from "../../common/components/CompetitionPage";

function EasterGiveawayExtraMain() {
  const offerId = REWARD_OFFERING.easterGiveawayExtra;

  return (
    <CompetitionPage
      offerId={offerId}
    />
  );
}

export default EasterGiveawayExtraMain;
